"use strict";

export default (function(){

	function linear(a, b) {
		a = a!==undefined && a!==null ? a : 1;
		b = b || 0;
		
		return (x => a*x + b);
	}

	function factor(a) {
		return linear(a, 0);
	}
	
	function convert(from, to, value) {
		
		if (!from || !to)
			return value;
		
		return conversionTables[from][to](value);
	}

	var conversionTables = {
		mm: {
			mm: factor(1),
			cm: factor(1/10),
			m: factor(1/10/100),
			km: factor(1/10/100/1000),
			in: factor(0.0393700787),
			ft: factor(0.0032808399),
			yd: factor(0.0010936133),
			mi: factor(6.21371192e-7)
		},
		cm: {
			mm: factor(10),
			cm: factor(1),
			m: factor(1/100),
			km: factor(1/100/1000),
			in: factor(0.393700787),
			ft: factor(0.032808399),
			yd: factor(0.010936133),
			mi: factor(6.21371192e-6)
		},
		m: {
			mm: factor(1000),
			cm: factor(100),
			m: factor(1),
			km: factor(1/1000),
			in: factor(39.3700787),
			ft: factor(3.2808399),
			yd: factor(1.0936133),
			mi: factor(0.000621371192)
		},
		km: {
			mm: factor(1000000),
			cm: factor(100000),
			m: factor(1000),
			km: factor(1),
			in: factor(39370.0787),
			ft: factor(3280.8399),
			yd: factor(1093.6133),
			mi: factor(0.621371192)
		},
		in: {
			mm: factor(25.4),
			cm: factor(2.54),
			m: factor(0.0254),
			km: factor(2.54e-5),
			in: factor(1),
			ft: factor(0.0833333333),
			yd: factor(0.0277777778),
			mi: factor(1.57828283e-5)
		},
		ft: {
			mm: factor(304.8),
			cm: factor(30.48),
			m: factor(0.3048),
			km: factor(0.0003048),
			in: factor(12),
			ft: factor(1),
			yd: factor(0.333333333),
			mi: factor(0.000189393939)
		},
		yd: {
			mm: factor(914.4),
			cm: factor(91.44),
			m: factor(0.9144),
			km: factor(0.0009144),
			in: factor(36),
			ft: factor(3),
			yd: factor(1),
			mi: factor(0.000568181818)
		},
		mi: {
			mm: factor(1609344),
			cm: factor(160934.4),
			m: factor(1609.344),
			km: factor(1.609344),
			in: factor(63360),
			ft: factor(5280),
			yd: factor(1760),
			mi: factor(1)
		},
		ms: {
			ms: factor(1),
			s: factor(1/1000),
			min: factor(1/1000/60),
			h: factor(1/1000/60/60),
			d: factor(1/1000/60/60/24),
			y: factor(1/1000/60/60/24/365.25)
		},
		s: {
			ms: factor(1000),
			s: factor(1),
			min: factor(1/60),
			h: factor(1/60/60),
			d: factor(1/60/60/24),
			y: factor(1/60/60/24/365.25)
		},
		min: {
			ms: factor(1000*60),
			s: factor(60),
			min: factor(1),
			h: factor(1/60),
			d: factor(1/60/24),
			y: factor(1/60/24/365.25)
		},
		h: {
			ms: factor(1000*60*60),
			s: factor(60*60),
			min: factor(60),
			h: factor(1),
			d: factor(1/24),
			y: factor(1/24/365.25)
		},
		d: {
			ms: factor(1000*60*60*24),
			s: factor(60*60*24),
			min: factor(60*24),
			h: factor(24),
			d: factor(1),
			y: factor(1/365.25)
		},
		y: {
			ms: factor(1000*60*60*24*365.25),
			s: factor(60*60*24*365.25),
			min: factor(60*24*365.25),
			h: factor(24*365.25),
			d: factor(365.25),
			y: factor(1)
		},
		kg: {
			kg: factor(1),
			lb: factor(2.20462262)
		},
		lb: {
			kg: factor(0.45359237),
			lb: factor(1)
		},
		l: {
			l: factor(1),
			gal: factor(0.264172052),
		},
		gal: {
			l: factor(3.78541178),
			gal: factor(1)
		},
		"km/h": {
			"km/h": factor(1),
			mph: factor(0.621371192)
		},
		mph: {
			"km/h": factor(1.609344),
			mph: factor(1)
		},
		V: {
			V: factor(1)
		},
		"l/100km": {
			"l/100km": factor(1),
			mpg: x => {
				var alfa = conversionTables['km']['mi'](1);
				var beta = conversionTables['l']['gal'](1);
				return 100*alfa/beta/x;
			}
		},
		mpg: {
			"l/100km": x => {
				var alfa = conversionTables['km']['mi'](1);
				var beta = conversionTables['l']['gal'](1);
				return 100*alfa/beta/x;
			},
			mpg: factor(1)
		},
		rpm: {
			rpm: factor(1)
		},
		'%': {
			'%': factor(1)
		},
		'°C': {
			'°C': factor(1),
			'°F': linear(1.8, 32),
			'°K': linear(1, 273.15)
		},
		'°F': {
			'°C': linear(1/1.8, -32/1.8),
			'°F': factor(1),
			'°K': linear(5/9, 459.67*5/9)
		},
		'°K': {
			'°C': linear(1, -273.15),
			'°F': linear(1.8, 32 - 1.8*273.15),
			'°K': factor(1)
		}
	};
	
	return convert;
	
})();


// WEBPACK FOOTER //
// ./~/vwa/quantity/convertUnit.js